<template>
  <v-container
    :style="$vuetify.theme.dark ? '' : 'background: #eeeeee'"
    style="min-height: 100vh"
  >
    <v-row class="mb-1">
      <v-col cols="12">
        <h2 class="mt-1">
          <span class="grey--text">{{ $t("drawer.plan") }}</span>
        </h2>
      </v-col>
      <!-- <v-col offset="7" md="2" class="mt-1" style="text-align: right"> </v-col> -->
    </v-row>
    <v-row v-if="userMe.role!=1?false :true">
      <v-col cols="12"> 
        <TablePayments :data="userMe.contracts.rows" />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <Pricing />
      </v-col>
    </v-row>
    <v-row class="justify-center">
      <v-col cols="12">
        <blog />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Pricing from "./Pricing.vue";
import blog from "../blog/index.vue";
import TablePayments from "./TablePayments.vue";
export default {
  name: "plan-page",
  components: { Pricing, blog, TablePayments },
  data() {
    return {};
  },

  computed: {
    userMe() {
      return this.$store.getters["users/userMe"];
    },
  },
};
</script>
